import * as y from "yup";

export const ReschedulingCampaignSchema = y.object({
  subject: y.string().required(),
  subject_preview: y.string().required(),
  message_from_venue: y.string().required(),
  message_from_venue_preview: y.string().required(),
  additional_message: y.string().optional(),
  additional_audiences: y
    .array()
    .of(y.string().email("Invalid email format"))
    .optional(),
  test_email_recipients: y.array().of(y.string().email("Invalid email format")).optional(),
  simulated_attendee_id: y.string().optional().nullable(),
  preheader: y.string().optional(),
  preview_value: y.string().optional(),
});

export type ReschedulingFormValues = y.InferType<typeof ReschedulingCampaignSchema>;

